// extracted by mini-css-extract-plugin
export default {"title":"Title_title__YWHQ5"};